import { css } from 'lit';
export default css `
  :host {
    width: 100%;
    height: 100%;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  amityeko-icon-badge {
    margin-bottom: 16px;
  }

  amityeko-tg-label-one {
    margin-bottom: 4px;
  }
`;
//# sourceMappingURL=styles.js.map